module.exports = __webpack_public_path__ + "static/media/new_video.2501d891.mp4";